
require('./bootstrap')

require('./globais')

// import ModalExcluir from './components/uteis/ModalExcluir.vue'

require('./filters')

import router from './routes'

import store from './store'

const app = new Vue({

    el: '#app',

    router,

    store,

    data(){
      return{
          carregando : true,
          // pagina_atual : this.$route.meta.title || 'Pagamentos' 
      }
    },

    methods: {
      carregado() {
         this.carregando = false
      },

      //fechar menu do botstrap
      menuClique(title){
        $(".navbar-collapse").collapse('hide');
        console.log(this.$route.meta.title);
        // this.$route.meta.title = title
      },

      isActive(title) {
        return this.$route.meta.title === title;
      }
    }



})
